import type { CartValidationErrorResponse, CartValidationResponse } from '@libs/common-node';
import { HttpStatus } from '@libs/core';

export class CartValidationError extends Error {
    readonly errorDetails: CartValidationErrorResponse;

    constructor(message: string, data: CartValidationErrorResponse) {
        super(message);

        this.errorDetails = data;
    }
}

export const isCartValidationErrorResponse = (
    response: CartValidationResponse | null
): response is CartValidationErrorResponse => response?.status === HttpStatus.UNPROCESSABLE_ENTITY;
